import React, {useEffect, useState}  from 'react'
import { QueryClient } from '@tanstack/react-query'
import { graphql, useStaticQuery } from 'gatsby'
import SchNetProgramsComponent from 'sch_net_programs_component'

const SchNetPrograms = ({ component: {  countryCode, duration, startYear } }) => {

  const [referrer,setReferrer] = useState()

  useEffect(() => {
    setReferrer(window.location.href)
  }, [])

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          crmApiUrl
          crmApiToken
          orderApiUrl
          orderApiToken
          tracking {
            mtUrl
            mtId
          }
        }
      }
    }
  `)

  const cfg = data.site.siteMetadata

  const schNetProgramsConfig = {
    upsell: true,
    upsellPrechecked: false,
    narrow: false,
    mtId: cfg.tracking.mtId,
    mtUrl: cfg.tracking.mtUrl,
    programApiUrl: 'https://www.schueleraustausch.net',
    orderApiUrl: cfg.orderApiUrl,
    orderApiToken: cfg.orderApiToken,
    crmApiUrl: cfg.crmApiUrl,
    crmApiToken: cfg.crmApiToken,
    referrer: referrer,
    filter: {
      countryCode: countryCode || 'US',
      duration: duration || '',
      startYear: startYear || null,
      price: null,
    }
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
      }
    }
  })

  return (
    <SchNetProgramsComponent {...schNetProgramsConfig} queryClient={queryClient} />
  )
}

export default SchNetPrograms
